module.exports = __webpack_public_path__ + "img/slika31.197fb90f.jpg";